var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mb-5",attrs:{"fluid":""}},[(_vm.$route.meta.breadcrumb)?_c('b-breadcrumb',{attrs:{"items":_vm.$route.meta.breadcrumb || []}}):_vm._e(),_c('b-card',[_c('WarehouseSoComponents')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }